// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"586":"96775161","592":"fe4449aa","647":"96775161"}[chunkId] + ".chunk.css";
};